import { isRight } from 'fp-ts/lib/Either';
import { ThunkResult } from '../../../redux/configureStore';
import * as actionCreators from './actionCreators';
import { UserInfoGateway } from '../../gateways/userInfoGateway.interface';

export const getUserAlcopaAccessUseCase =
    (sourceIds: number[]): ThunkResult<void> =>
    async (dispatch, getState, { userInfoGateway }: { userInfoGateway: UserInfoGateway }) => {
        dispatch(actionCreators.Actions.getAlcopaAccessRequested());
        let hasAlcopaAccess = false;
        // eslint-disable-next-line no-restricted-syntax
        for (const sourceId of sourceIds) {
            // eslint-disable-next-line no-await-in-loop
            const resultData = await userInfoGateway.getCarcheckSource(sourceId);
            if (isRight(resultData) && resultData.right.sourceGroupData?.alcopa) {
                hasAlcopaAccess = true;
                break;
            }
        }
        dispatch(actionCreators.Actions.getAlcopaAccessSucceeded(hasAlcopaAccess));
    };
